import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInboxFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.6004 3.00002C12.6004 2.66865 12.3318 2.40002 12.0004 2.40002C11.669 2.40002 11.4004 2.66865 11.4004 3.00002V9.5515L9.42465 7.57576C9.19034 7.34145 8.81044 7.34145 8.57613 7.57576C8.34181 7.81007 8.34181 8.18997 8.57613 8.42429L11.5761 11.4243C11.8104 11.6586 12.1903 11.6586 12.4247 11.4243L15.4247 8.42429C15.659 8.18997 15.659 7.81007 15.4247 7.57576C15.1903 7.34145 14.8104 7.34145 14.5761 7.57576L12.6004 9.5515V3.00002ZM3.43119 6.81029C3.51285 6.56528 3.74214 6.40002 4.0004 6.40002H6.00039V7.60002H4.43285L2.83285 12.4H8.50039C8.64408 12.4 8.77597 12.4505 8.87928 12.5348C9.01424 12.6448 9.10043 12.8124 9.10043 13V15.4H14.9004V13C14.9004 12.6687 15.169 12.4 15.5004 12.4H21.1679L19.5679 7.60002H18.0004V6.40002H20.0004C20.2587 6.40002 20.4879 6.56528 20.5696 6.81029L22.5679 12.8053C22.6051 12.9136 22.611 13.0317 22.5825 13.1456L20.5825 21.1456C20.5157 21.4127 20.2757 21.6 20.0004 21.6H4.00042C3.7251 21.6 3.48511 21.4127 3.41834 21.1456L1.41966 13.1509C1.39089 13.0401 1.39401 12.9218 1.43119 12.8103L3.43119 6.81029Z",
		fill: "currentColor"
	})
});
export default SvgInboxFilled;
